import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { DownloadSectionComponent } from '@yme/molecules/download-section';
import { getRTL } from '@yme/selectors/common';
import { DOWNLOAD_SECTION_DATA_TEST_ID } from './constants';
export function DownloadSection(props) {
    const { files, labels, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    const { downloadSection_header_label: downloadsTitle } = labels;
    if (files?.length > 0) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, { dataTestId: DOWNLOAD_SECTION_DATA_TEST_ID, isRightToLeft: isRightToLeft },
                React.createElement(Row, { justifyContent: "center" },
                    React.createElement(Col, { lg: 6, md: 8, sm: 4 },
                        React.createElement(DownloadSectionComponent, { files: files, title: downloadsTitle, isRightToLeft: isRightToLeft }))))));
    }
    return null;
}
DownloadSection.displayName = 'DownloadSection_AEMComponent';
